/**
 * SignInLayout Component
 * 
 * Layout wrapper for authentication pages.
 * Provides theme-aware background and centering.
 */

/**
 * SignInLayout component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to render
 */
export function SignInLayout({ children }) {
  return (
    <div
      className="min-h-screen w-full flex justify-center items-center relative py-12 px-4 overflow-y-auto"
      style={{
        background: 'var(--color-background-secondary)',
      }}
    >
      {/* Decorative gradient orb - top right */}
      <div
        className="fixed top-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{
          background: 'var(--color-primary)',
          transform: 'translate(30%, -30%)',
        }}
      />

      {/* Decorative gradient orb - bottom left */}
      <div
        className="fixed bottom-0 left-0 w-96 h-96 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{
          background: 'var(--color-primary)',
          transform: 'translate(-30%, 30%)',
        }}
      />

      {children}
    </div>
  );
}

export default SignInLayout;
